"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StencilConsumer = exports.StencilProvider = exports.STENCIL_CONTEXT_PROPS = exports.StencilContext = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@emotion/core");

var _emotionTheming = require("emotion-theming");

var _stencilReactThemeDefault = _interopRequireDefault(require("@amzn/stencil-react-theme-default"));

var _liveAnnouncer = require("../live-announcer");

var _GlobalCSS = require("./GlobalCSS");

var _FontCSS = require("./FontCSS");

var _themeSelectors = require("./themeSelectors");

var StencilContext = (0, _react.createContext)({
  theme: _stencilReactThemeDefault.default,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setTheme: function setTheme(_) {},
  // @ts-ignore There's no sensible default for 'selectors'
  selectors: {}
});
exports.StencilContext = StencilContext;
var STENCIL_CONTEXT_PROPS = ['theme', 'setTheme', 'selectors'];
exports.STENCIL_CONTEXT_PROPS = STENCIL_CONTEXT_PROPS;

var StencilProvider =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(StencilProvider, _Component);

  function StencilProvider() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, StencilProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(StencilProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      theme: _this.props.theme || _stencilReactThemeDefault.default
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectors", {
      color: _this.bindTheme(_themeSelectors.selectColor),
      colorOrNull: _this.bindTheme(_themeSelectors.selectColorOrNull),
      fontFamily: _this.bindTheme(_themeSelectors.selectFontFamily),
      fontSize: _this.bindTheme(_themeSelectors.selectFontSize),
      lineHeight: _this.bindTheme(_themeSelectors.selectLineHeight),
      fontWeight: _this.bindTheme(_themeSelectors.selectFontWeight),
      space: _this.bindTheme(_themeSelectors.selectSpace),
      breakpoint: _this.bindTheme(_themeSelectors.selectBreakpoint),
      zIndex: _this.bindTheme(_themeSelectors.selectZIndex),
      constant: _this.bindTheme(_themeSelectors.selectConstant)
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setTheme", function (theme) {
      return _this.setState({
        theme: theme
      });
    });
    return _this;
  }

  (0, _createClass2.default)(StencilProvider, [{
    key: "bindTheme",
    value: function bindTheme(selector) {
      var _this2 = this;

      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return selector.apply(void 0, [_this2.state.theme].concat(args));
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!!this.props.theme && this.props.theme !== prevProps.theme) {
        this.setState({
          theme: this.props.theme
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          emberUrl = _this$props.emberUrl,
          emotionCache = _this$props.emotionCache,
          shouldAddLiveAnnouncer = _this$props.shouldAddLiveAnnouncer,
          shouldUseResponsiveText = _this$props.shouldUseResponsiveText;
      var theme = this.state.theme;
      var setTheme = this.setTheme,
          selectors = this.selectors;
      var fontCSS = (0, _FontCSS.getFontCSS)(emberUrl);
      var globalCSS = (0, _GlobalCSS.getGlobalCSS)(theme);
      var provider = (0, _core.jsx)(StencilContext.Provider, {
        value: {
          theme: theme,
          setTheme: setTheme,
          selectors: selectors
        }
      }, (0, _core.jsx)(_emotionTheming.ThemeProvider, {
        theme: {
          selectors: selectors,
          values: theme,
          shouldUseResponsiveText: shouldUseResponsiveText
        }
      }, (0, _core.jsx)(_react.default.Fragment, null, shouldAddLiveAnnouncer ? (0, _core.jsx)(_liveAnnouncer.LiveAnnouncer, null, children) : children, (0, _core.jsx)(_core.Global, {
        styles: fontCSS
      }), (0, _core.jsx)(_core.Global, {
        styles: globalCSS
      })))); // Only wrap with an emotion cache provider if a cache was passed in,
      // because otherwise we'd have to provide a cache and we want to use
      // the default one if a custom one wasn't passed in.

      return !!emotionCache ? (0, _core.jsx)(_core.CacheProvider, {
        value: emotionCache
      }, provider) : provider;
    }
  }]);
  return StencilProvider;
}(_react.Component); // Only the Context object can have a display name, not the consumer.
// The consumer will automatically be named `${Context.displayName}.Consumer`


exports.StencilProvider = StencilProvider;
(0, _defineProperty2.default)(StencilProvider, "displayName", 'StencilProvider');
(0, _defineProperty2.default)(StencilProvider, "propTypes", {
  theme: _propTypes.default.any,
  emberUrl: _propTypes.default.string,
  shouldAddLiveAnnouncer: _propTypes.default.bool,
  shouldUseResponsiveText: _propTypes.default.bool
});
(0, _defineProperty2.default)(StencilProvider, "defaultProps", {
  theme: _stencilReactThemeDefault.default,
  shouldAddLiveAnnouncer: true,
  shouldUseResponsiveText: true
});
StencilContext.displayName = 'StencilContext';
var StencilConsumer = StencilContext.Consumer;
exports.StencilConsumer = StencilConsumer;